var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('widget',{attrs:{"color":"primary","title":"Prospect Overview"}},[_c('div',{staticClass:"md-layout md-gutter"},[_c('div',{staticClass:"md-layout-item md-small-size-100 md-xsmall-size-100 md-medium-size-100 md-size-100"},[_c('Credential')],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }